import Layout from '../views/layout/Layout'

export default {
  path: '/data',
  component: Layout,
  redirect: '/data/index',
  name: 'data',
  meta: {title: '数据中心', icon: 'data-center'},
  children: [
    {
      path: 'childrenList',
      name: 'childrenList',
      component: () => import('@/views/data/childrenList'),
      meta: {title: '我的信息', icon: 'constitution'}
    },
    {
      path: 'clientModify',
      name: 'clientModify',
      component: () => import('@/views/data/clientModify'),
      meta: {title: '编辑信息', icon: 'constitution'},
      hidden: true
    },
    {
      path: 'index',
      name: 'index',
      component: () => import('@/views/data/index'),
      meta: {title: '体质检测', icon: 'constitution'}
    },
    {
      path: 'word',
      name: 'word',
      component: () => import('@/views/data/word'),
      meta: {title: '检测问卷 ', icon: 'word'}
    },
    {
      path: 'mood',
      name: 'mood',
      component: () => import('@/views/data/mood'),
      meta: {title: '检测情绪', icon: 'mood'}
    },
    {
      path: 'wx-data',
      name: 'wx-data',
      component: () => import('@/views/data/wx-data'),
      meta: {title: '小程序数据 ', icon: 'constitution'}
    },
    {
      path: 'statistics',
      name: 'statistics',
      component: () => import('@/views/data/analysis-day'),
      meta: {title: '按日分析', icon: 'statistics'}
    },
    {
      path: 'statistics-batch',
      name: 'statistics-batch',
      component: () => import('@/views/data/batch-analysis-day'),
      meta: {title: '批量按日分析', icon: 'statistics'},
      hidden: true
    },
    {
      path: 'report',
      name: 'report',
      component: () => import('@/views/data/report/index'),
      meta: {title: '查看报告与问卷详情', icon: 'store-list'},
      hidden: true
    },
    {
      path: 'moodReport',
      name: 'moodReport',
      component: () => import('@/views/data/moodReport/index.vue'),
      meta: {title: '查看情绪报告详情', icon: 'store-list'},
      hidden: true
    },
    {
      path: 'edit',
      name: 'edit',
      component: () => import('@/views/data/report/edit'),
      meta: {title: '编辑调养方案'},
      hidden: true
    },
    {
      path: 'dataAnalysis',
      name: 'dataAnalysis',
      component: () => import('@/views/data/analysis-month'),
      meta: {title: '按月分析', icon: 'statistic'},
    },
    {
      path: 'dataAnalysis-batch',
      name: 'dataAnalysis-batch',
      component: () => import('@/views/data/batch-analysis-month'),
      meta: {title: '批量按月分析', icon: 'statistic'},
      hidden: true
    },
    {
      path: 'analysisByDayAndCompany',
      name: 'analysisByDayAndCompany',
      component: () => import('@/views/data/analysisByDayAndCompany'),
      meta: {title: '公司分析', icon: 'companyAnalysis'}
    },
    {
      path: 'imageDownload',
      name: 'imageDownload',
      component: () => import('@/views/data/image-download/image-download.vue'),
      meta: {title: '图片下载', icon: 'picture'}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/data.js